// @flow
import * as React from 'react';
import Box from 'sail/Box';
import {CompactTooltip} from 'sail/Tooltip';
import {defineMessages, FormattedMessage} from 'react-intl';
import {FlagIcon} from '../FlagIcon/FlagIcon';
import type {FlagCountryCode} from '../FlagIcon/FlagIcon';

type AvailabilityProps = {|
  countries: Array<FlagCountryCode>,
|};

const messages = defineMessages({
  available: {
    id: 'docsApp.components.availability.available',
    description: 'Text shown before list of countries service is available in',
    defaultMessage: 'Available in: ',
  },
});

export const Availability = ({countries}: AvailabilityProps) => {
  return (
    <Box flex={{alignItems: 'center'}}>
      <FormattedMessage {...messages.available} />
      {countries.map((country) => (
        <Box key={country} padding={{left: 8}}>
          <CompactTooltip
            context={<FlagIcon country={country} inline={false} />}
            label={country}
          />
        </Box>
      ))}
    </Box>
  );
};
